<template>
  <el-table-column type="selection" width="46" align="center"
                   v-bind="$attrs" v-on="$listeners"></el-table-column>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {},
  extends: BaseVue,
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">

</style>